import { render } from "./respuesta.vue?vue&type=template&id=16e30388&scoped=true"
import script from "./respuesta.vue?vue&type=script&lang=js"
export * from "./respuesta.vue?vue&type=script&lang=js"

import "./respuesta.vue?vue&type=style&index=0&id=16e30388&scoped=true&lang=css"
import "./respuesta.vue?vue&type=style&index=1&id=16e30388&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e30388"]])

export default __exports__